import React from 'react';
import { Badge } from 'primereact/badge';
import { getStateDisplayInfo } from '../../utils/licenseStates';
import { LicenseTransactionEntity } from '../../types';

type License = LicenseTransactionEntity & { canExpire?: boolean };

interface LicenseStatusProps {
  license: License;
  showIcon?: boolean;
  size?: 'normal' | 'small';
  showExpiryWarning?: boolean;
}

const LicenseStatus = ({
  license,
  showIcon = true,
  size = 'normal',
  showExpiryWarning = true
}: LicenseStatusProps) => {
  const stateInfo = getStateDisplayInfo(license);
  // For expiry warnings, use the appropriate date based on license status
  // Active licenses: check plannedEndDate (endDate is null)
  // Expired licenses: already handled by status check (no warning shown)
  const dateToCheck = license.status === 'Expired' ? license.endDate : license.plannedEndDate;

  const expiryWarning = showExpiryWarning &&
    license.canExpire &&
    dateToCheck &&  // Check both endDate (expired) and plannedEndDate (active)
    license.status !== 'Expired' &&  // Don't show warning for already expired licenses
    new Date(dateToCheck) < new Date(Date.now() + 30 * 24 * 60 * 60 * 1000); // 30 days

  return (
    <div className="flex align-items-center gap-2">
      <Badge
        value={stateInfo.status}
        style={{
          backgroundColor: expiryWarning ? '#ff6b35' : stateInfo.color,
          color: '#ffffff',
          border: expiryWarning ? '2px solid #ff4500' : 'none'
        }}
        className={size === 'small' ? 'text-sm' : ''}
      >
        {showIcon && stateInfo.icon && (
          <i className={`pi ${stateInfo.icon} ${size === 'small' ? 'text-sm' : ''} mr-1`}></i>
        )}
        {stateInfo.status}
      </Badge>

      {expiryWarning && (
        <i
          className="pi pi-exclamation-triangle text-orange-500"
          title={`Expires on ${new Date(dateToCheck).toLocaleDateString()}`}
        ></i>
      )}
    </div>
  );
};

export default LicenseStatus;
